var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart08-template',{attrs:{"board-ids":[108, 156, 157, 158, 159],"data-type":_vm.dataType,"field-code":"public-transportation","graph-id":56,"title":"(공중교통수단) 유해·위험요인 조사 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }